var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"650ada93defaf1a9e70b06cc86cb7c0c4cc45442"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["san-marino@san-marino"]={id:"650ada93defaf1a9e70b06cc86cb7c0c4cc45442"};
      